import angular from 'angular';

import '../../services/donation';
import '../../services/payment';

angular.module("folkeuni").component("donationForm", {
    bindings: {
        siteId: "@",
        refundGuid: "@"
    },
    controller: function (Donation, $timeout, PaymentService) {
        var $ctrl = this;
        $ctrl.maxAmount = null;
        $ctrl.errorMessage = null;
        $ctrl.amountTooBig = false;
        $ctrl.showCprWarning = false;
        $ctrl.cprNotValid = false;

        $ctrl.donation = {
            siteId: $ctrl.siteId,
            amount: null,
            firstName: "",
            lastName: "",
            email: "",
            cpr: "",
            cvr: ""
        };

        $ctrl.acceptTerms = false;
        $ctrl.stepActive = 1;

        $ctrl.termsError = null;
        $ctrl.ErrorTimer = null;

        $ctrl.setStep = function (step) {
            $ctrl.stepActive = step;
        };

        $ctrl.confirmData = function () {
            if ($ctrl.cprNotValid || $ctrl.amountTooBig) {
                return false;
            } else if ($ctrl.donation.amount != null) {
                $ctrl.setStep(2);
            }
        };

        $ctrl.sendDonation = function () {
            if ($ctrl.donation.email) {
                $ctrl.donation.email = $ctrl.donation.email.toLowerCase();
            }

            if (!$ctrl.acceptTerms) {
                $ctrl.termsError = "Før vi kan acceptere din donation, skal du acceptere at vi opbevarer din data";
            } else {
                $ctrl.termsError = null;
                Donation.sendDonation($ctrl.donation).then(
                    function (checkout) {
                        if ($ctrl.refundGuid) {
                            window.location.href = checkout.url;
                        } else {
                            PaymentService.openPaymentWindow(checkout);
                        }
                    },
                    function (error) {
                        if (error.status === 409) {
                            $ctrl.termsError = error.data;
                        } else {
                            $ctrl.termsError =
                                "Der skete en fejl forbindelse med donationen, tjek venligst om e-mail og CPR er gyldigt";
                        }
                    }
                );
            }
        };

        $ctrl.validateCpr = function () {
            if ($ctrl.donation.cpr) {
                var cprObj = cprValid($ctrl.donation.cpr);
                $ctrl.cprNotValid = !cprObj.date;
                $ctrl.showCprWarning = !cprObj.modulus;
            } else {
                $ctrl.showCprWarning = false;
                $ctrl.cprNotValid = false;
            }
        };

        $ctrl.validateAmount = function () {
            if ($ctrl.refundGuid && $ctrl.maxAmount && $ctrl.donation.amount > $ctrl.maxAmount) {
                $ctrl.amountTooBig = true;
            } else {
                $ctrl.amountTooBig = false;
            }
        };

        $ctrl.$onInit = function () {
            $ctrl.donation.siteId = $ctrl.siteId;

            if ($ctrl.refundGuid) {
                var refundObj = {
                    siteId: $ctrl.siteId,
                    guid: $ctrl.refundGuid
                };
                Donation.fetchRefundData(refundObj)
                    .then(function (res) {
                        $ctrl.maxAmount = res.maxAmount;
                        $ctrl.donation.firstName = res.firstName;
                        $ctrl.donation.lastName = res.lastName;
                        $ctrl.donation.email = res.email;

                        $ctrl.donation.refundGuid = $ctrl.refundGuid;

                        // Replace ||amount|| from Umbraco with max amount from refund obj
                        var introDescriptionElement = document.querySelector(".intro-description");
                        if (introDescriptionElement) {
                            introDescriptionElement.innerHTML = introDescriptionElement.innerHTML.replace(
                                "||amount||",
                                $ctrl.maxAmount
                            );
                        }
                    })
                    .catch(function (err) {
                        $ctrl.errorMessage = err.data;
                    });
            }
        };

        function cprValid(cpr) {
            function cprValidObj(date, modulus) {
                return {
                    date: date,
                    modulus: modulus
                };
            }

            function isValidDate(s) {
                var bits = s.split("-");
                var d = new Date(s);
                return (
                    d.getFullYear() == Number(bits[0]) &&
                    d.getMonth() + 1 == Number(bits[1]) &&
                    d.getDate() == Number(bits[2])
                );
            }

            if (typeof cpr !== "string") {
                return cprValidObj(false, false);
            }

            var regex = /^(?<d>\d\d)(?<m>\d\d)(?<y>\d\d)(?<c1>\d)(?<c2>\d)(?<c3>\d)(?<c4>\d)$/gm;
            var match = regex.exec(cpr);
            if (!match) return cprValidObj(false, false);

            var day = parseInt(match.groups["d"]);
            var month = parseInt(match.groups["m"]);
            var year = parseInt(match.groups["y"]);
            var c7 = parseInt(match.groups["c1"]);
            var c8 = parseInt(match.groups["c2"]);
            var c9 = parseInt(match.groups["c3"]);
            var c10 = parseInt(match.groups["c4"]);

            switch (c7) {
                case 0:
                case 1:
                case 2:
                case 3:
                    year = 1900 + year;
                    break;

                case 4:
                    if (0 <= year && year <= 36) year = 2000 + year;
                    else year = 1900 + year;
                    break;

                case 5:
                case 6:
                case 7:
                case 8:
                    if (0 <= year && year <= 57) year = 2000 + year;
                    else year = 1800 + year;
                    break;

                case 9:
                    if (0 <= year && year <= 36) year = 2000 + year;
                    else year = 1900 + year;
                    break;
            }

            var dateString = year + "-" + (month < 10 ? "0" : "") + month + "-" + (day < 10 ? "0" : "") + day;
            if (!isValidDate(dateString)) {
                return cprValidObj(false, false);
            }

            var sum = 0;
            var weight = [4, 3, 2, 7, 6, 5, 4, 3, 2, 1];
            for (var i = 0; i < cpr.length; i++) {
                sum += cpr[i] * weight[i];
            }

            var validModulus = sum % 11 == 0;

            if (validModulus) return cprValidObj(true, true);

            return cprValidObj(true, false);
        }
    },
    templateUrl: "/shop-dist/templates/donation-form.html?c" + window.cacheBurst,
    transclude: {
        introDescription: "?description",
        confirmDonationDescription: "?confirmDonation"
    }
});